
import FlowForm from './FlowForm'

const getFlow = ({ flow, id, param, onFinish, onClose, onFlowFinished }) => {

	const doShowDialog = (act, Comp) => {
		// const doCloseDialog = () => closeDialog && closeDialog()
		const { closeDialog } = Tyan.pubForm.showDialog(act.act, Comp,
			{
				id, flowName: flow, flowAct: act, param,
				onFinish: () => handleFinish({ closeDialog/* : doCloseDialog */, act }),
				onConfirm: ({ values = {}, button }) => doAct({ act, button, values, closeDialog })
			}
		)
	}

	const doShowForm = ({ act, button }) => {
		const Form = Tyan.forms[act.form]
		if (!Form) {
			// Ext.toast('系统配置错误，请与系统管理员联系')
			Tyan.pubForm.showError('系统配置错误，请与系统管理员联系')
			console.error('系统配置错误, 找不到指定的 form:', act)
			return
		}
		doShowDialog(act, Form)
	}

	const doShowFlowForm = ({ act, button }) => {
		doShowDialog(act, FlowForm)
	}

	const handleFinish = ({ closeDialog, act, destStatus }) => {
		closeDialog && closeDialog()
		if (onFinish)
			onFinish(act)
		else {
			// Ext.toast('操作成功')
			Ext.toast('操作成功' + (destStatus ? `，下一环节为：${destStatus}` : ''))
			onClose && onClose()
			onFlowFinished && onFlowFinished(act)
		}
	}

	const doAct = ({ act, button, values = {}, closeDialog }) => {
		const doEvent = () => Tyan.doPostEvent('DoFlowAct', {
			data: { flow, id, act: act.act, status: act.status, input: values, param },
			sourceComponent: button,
			onEnd: ({ errorMessage, destStatus }) => {
				// errorMessage && Ext.toast(errorMessage)
				errorMessage && Tyan.pubForm.showError(errorMessage)
				!errorMessage && handleFinish({ closeDialog, act, destStatus })
			}
		})

		closeDialog ? doEvent() : Tyan.pubForm.showConfirm(`确定要 ${act.act} ?`, doEvent)
	}


	const handleAct = arg => {
		const { act } = arg
		act.form
			? doShowForm(arg)
			: act.components
				? doShowFlowForm(arg)
				: doAct(arg)
	}


	return new Promise(resolve => {
		Tyan.doPostEvent('GetFlowActs', {
			data: { flow, id, param },
			onEnd: ({ errorMessage, acts = [] }) => {
				errorMessage && (/* Ext.toast(errorMessage), */Tyan.pubForm.showError(errorMessage), console.error(`取流程信息 ${flow} : ${id} 错误:`, errorMessage))
				acts = acts.map(act => (act.config = { _button: act.act, handler: button => handleAct({ act, button }) }, act))

				resolve({ errorMessage, acts })
			}
		})
	})
}

export { getFlow }